/**
 * Custom Cart Adjustments for Boost Cart Drawer
 * 
 * This script modifies the Boost Cart drawer to:
 * 1. Keep only "Remove" option for specific products (hide quantity options)
 * 2. Hide price element for the first product
 */

function adjustCartItems() {
  console.log('Just call checking');
  // Target product IDs where we hide quantity options
  const targetProductIds = ['10170411811117', '10166409822509', '10190507475245', '10190507704621'];
  
  // First product ID where we also hide the price
  const firstProductId = '10170411811117';
  
  // Get the main cart container
  const boostCartMain = document.getElementById('boostCartMain');
  if (!boostCartMain) return;
  
  // Get all cart items
  const cartItems = boostCartMain.querySelectorAll('.boost-cart__items li');
  
  // Process each cart item
  cartItems.forEach((liElement) => {
    const productId = liElement.getAttribute('data-product-id');
    
    // Check if this product ID is in the target list
    if (targetProductIds.includes(productId)) {
      // Find all quantity/option select elements
      const selectOptions = liElement.querySelectorAll(
        '.boost-cart__item-info-right .boost-cart__select-options .boost-cart__select-option'
      );
      
      // Keep only "Remove" option (first one), hide quantity options
      selectOptions.forEach((option, index) => {
        if (index === 0) {
          // This is "Remove" - keep it visible
          option.style.display = '';
        } else {
          // These are quantity options - hide them
          option.style.display = 'none';
        }
      });
    } else {
      console.log('Hidden');
      // Find all quantity/option select elements
      const selectOptions = liElement.querySelectorAll(
        '.boost-cart__item-info-right .boost-cart__select-options .boost-cart__select-option'
      );
      
      // show the randomly hidden elements again
      selectOptions.forEach(option => {
        option.style.display = '';
      });
    }
    
    // For the first product, also hide the price element
    if (productId === firstProductId) {
      const priceElement = liElement.querySelector('.boost-cart__item-price');
      // const rightElement = liElement.querySelector('.boost-cart__item-info-right');
      
      if (priceElement) {
        priceElement.style.display = 'none';
      }

      // if (rightElement) {
      //   rightElement.style.display = 'none';
      // }
    }
  });
}

// Run adjustments when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', adjustCartItems);
} else {
  adjustCartItems();
}

// Watch for changes to the cart drawer using MutationObserver
const boostCartMain = document.getElementById('boostCartMain');
if (boostCartMain) {
  const observer = new MutationObserver(() => {
    adjustCartItems();
  });
  
  // Observe all changes to the cart container
  observer.observe(boostCartMain, {
    childList: true,      // Watch for added/removed nodes
    // subtree: true,        // Watch all descendants
    // attributes: true,     // Watch attribute changes
    // characterData: true   // Watch text node changes
  });

  boostCartMain.addEventListener('click', (e) => {
    // Check if clicked element is a remove button (first-child select-option)
    if (e.target.classList.contains('boost-cart__select-option')) {
      const selectOptions = e.target.parentElement.querySelectorAll('.boost-cart__select-option');
      // If it's the first option (remove), call adjustCartItems after 1 second
      if (e.target === selectOptions[0]) {
        console.log("PRECALLING");
        setTimeout(() => {
          adjustCartItems();
        }, 3000);
      }
    }
  });
}
